module.exports = __webpack_public_path__ + "static/img/texture-bw.054ae23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/texture-bw.png
// module id = 2Pa5
// module chunks = 0